import type { LoanApplication } from '@/types/LoanApplicationType';

/**
 * True when the applicant's answers changed after they last attested.
 * Compares `answersUpdatedAt`, which the server moves only when an answer
 * actually changes. `updatedAt` also moves on checklist, document and status
 * saves, and on the attestation save itself, so comparing it marked every
 * fresh attestation out of date.
 */
export function isLoanAttestationSupersededByEdits(
  app: LoanApplication
): boolean {
  const acceptedAt = app.signAttestation?.acceptedAt;
  if (!acceptedAt) return false;
  const answersUpdatedAt = app.answersUpdatedAt;
  if (!answersUpdatedAt) return false;
  return new Date(answersUpdatedAt).getTime() > new Date(acceptedAt).getTime();
}

/** User must (re-)open the attestation flow and submit. */
export function loanAttestationNeedsRecording(app: LoanApplication): boolean {
  if (!app.signAttestation?.acceptedAt) return true;
  return isLoanAttestationSupersededByEdits(app);
}

/** Attestation on file and still matches latest application save. */
export function loanAttestationIsCurrent(app: LoanApplication): boolean {
  return (
    Boolean(app.signAttestation?.acceptedAt) &&
    !isLoanAttestationSupersededByEdits(app)
  );
}
